<template>
  <div class="target-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="12" align="left">
        <!-- 新增精度靶按钮 -->
        <el-button v-if="hasPermission('target:edit')" icon="el-icon-plus" type="primary" @click="openAddDialog"
          v-hasPermission="'target:edit'">新增精度靶</el-button>
        <el-button icon="el-icon-monitor" type="success" @click="$router.push({ name: 'ShootingScoreList' })"
          v-hasPermission="'target:show'">成绩面板</el-button>
        <!-- 批量操作按钮（选中精度靶后可用） -->
        <el-button v-if="hasPermission('target:edit')" icon="el-icon-delete" type="danger" v-hasPermission="'target:edit'" @click="handleBatchDelete"
          :disabled="!hasPermission('target:edit') || selectedIds.length === 0">批量删除</el-button>
        <!-- <el-button v-if="hasPermission('target:edit')" icon="el-icon-upload2" @click="openImportDialog" v-hasPermission="'target:edit'">批量导入</el-button>
        <el-button v-if="hasPermission('target:edit')" icon="el-icon-download" @click="exportTargets" v-hasPermission="'target:edit'">批量导出</el-button> -->
        <!-- <el-button v-if="hasPermission('target:edit')" icon="el-icon-printer" v-hasPermission="'target:edit'" @click="batchPrintQrCode"
          :disabled="!hasPermission('target:edit') || selectedIMEIs.length === 0">批量打印二维码</el-button>
        <el-button v-if="hasPermission('target:edit')" icon="el-icon-document-copy" type="primary" v-hasPermission="'target:edit'" @click="batchDownloadQrCode"
          :disabled="!hasPermission('target:edit') || selectedIMEIs.length === 0">批量下载二维码</el-button> -->
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="12" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-row>
            <el-form-item label="组织机构">
              <el-select v-model="searchForm.orgIds" filterable multiple placeholder="请选择组织机构" clearable>
                <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型">
              <el-select v-model="searchForm.deviceType" filterable placeholder="请选择设备类型" clearable>
                <el-option v-for="item in deviceTypeOptions" :key="item.dictItemKey" :label="item.dictItemValue" :value="item.dictItemKey"></el-option>
              </el-select>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="loadTargets">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
            <el-button @click="showExtend = !showExtend"
              :icon="showExtend ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></el-button>
          </el-row>
          <el-row :gutter="20" v-if="showExtend">
            <el-form-item label="设备状态">
              <el-select v-model="searchForm.devStatus" placeholder="请选择设备状态" clearable>
                <el-option :value="1" label="正常"></el-option>
                <el-option :value="0" label="停用"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="IMEI">
              <el-input v-model="searchForm.imei" placeholder="请输入IMEI" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="ICCID">
              <el-input v-model="searchForm.iccid" placeholder="请输入ICCID" maxlength="50"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="targets" border stripe style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="orgName" label="组织机构名称" header-align="center"></el-table-column>
      <el-table-column prop="warZone" label="战区" align="center" width="80"></el-table-column>
      <el-table-column prop="targetNo" label="靶编号" align="center" width="80"></el-table-column>
      <el-table-column prop="imei" label="IMEI" header-align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" header-align="center" width="200"></el-table-column>
      <el-table-column prop="onlineStatus" label="在线状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.onlineStatus === 1 ? 'success' : 'danger'">
            {{ scope.row.onlineStatus === 1 ? '在线' : '离线' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="devStatus" label="设备状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.devStatus === 1 ? 'success' : 'danger'">
            {{ scope.row.devStatus === 1 ? '正常' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="deviceTypeName" label="设备类型" align="center"></el-table-column>
      <el-table-column prop="version" label="版本信息" header-align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
      <!-- <el-table-column label="二维码" align="center" width="80">
        <template slot-scope="scope">
          <img :src="require('@/assets/qr-code.png')" alt="二维码" style="width: 30px; height: 30px;" @click="previewQrCode(scope.row)">
        </template>
      </el-table-column> -->
      <el-table-column prop="createTime" label="创建时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center" width="200"></el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-tooltip content="编辑" placement="top" v-if="hasPermission('target:edit')">
            <el-button icon="el-icon-edit" type="primary" circle v-hasPermission="'target:edit'"
              @click="openEditDialog(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="成绩面板" placement="top">
            <el-button icon="el-icon-monitor" type="success" circle v-hasPermission="'target:show'"
              @click="$router.push({ name: 'ShootingScore', query: { imei: scope.row.imei, roundStatus: '0', target: scope.row } })"></el-button>
          </el-tooltip>
          <el-tooltip content="删除" placement="top" v-if="hasPermission('target:edit')">
            <el-button icon="el-icon-delete" type="danger" circle v-hasPermission="'target:edit'"
              @click="handleDelete(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        <el-form-item label="组织机构" prop="orgId">
          <el-select v-model="form.orgId" filterable placeholder="请选择组织机构" clearable style="width: 100%">
            <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IMEI" prop="imei">
          <el-input v-model="form.imei" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="ICCID" prop="iccid">
          <el-input v-model="form.iccid" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="deviceType">
          <el-select v-model="form.deviceType" filterable placeholder="请选择设备类型" clearable style="width: 100%">
            <el-option v-for="item in deviceTypeOptions" :key="item.dictItemKey" :label="item.dictItemValue" :value="item.dictItemKey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本信息" prop="version">
          <el-input v-model="form.version" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" rows="3" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog :visible.sync="importDialogVisible" title="批量导入" width="600px">
      <el-form :model="importForm">
        <el-form-item prop="file">
          <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleFileChange" :limit="1"
            accept=".xlsx, .xls" :file-list="fileList">
            <el-button type="primary">点击上传</el-button>
            <div slot="tip" class="template-tip">仅支持.xlsx/.xls格式，不超过5MB</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="downloadTemplate">下载导入模板</el-button>
          <div class="template-tip">模板包含必填项和格式限制，请严格按照模板填写</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelImport">取消</el-button>
        <el-button type="primary" @click="submitImport">确认导入</el-button>
      </div>
    </el-dialog>

    <!-- 二维码预览弹窗 -->
    <el-dialog :visible.sync="qrCodeDialogVisible" title="设备二维码"  width="400px">
      <div class="qr-code-preview">
        <img :src="qrCodeImageUrl" alt="设备二维码" style="width: 100%;" />
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="printQrCode">打印二维码</el-button>
        <el-button type="primary" @click="downloadSingleQrCode(currentTarget)">下载图片</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import targetApi from '../../api/target';
import dictApi from '../../api/dictionary'
import { hasPermission } from '../../utils/hasPermission';
import store from '../../store';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import config from '../../config/config';

export default {
  name: 'TargetList',
  data() {
    // IMEI唯一校验
    const checkImeiUnique = async (rule, value, callback) => {
      if (!value) {
        // 空值不校验（由required规则处理）
        return callback()
      }

      try {
        const params = {
          uniqueType: "imei",
          uniqueCode: value,
          excludeId: this.isEdit ? this.recordId : null
        }
        // 调用后端查重接口
        const response = await targetApi.checkUniqueCode(params)
        if (response.success && response.exists) {
          // IMEI已存在，返回错误提示
          callback(new Error('该IMEI已被使用，请更换'))
        } else {
          // IMEI可用，验证通过
          callback()
        }
      } catch (error) {
        callback(new Error('检查失败，请稍后重试'))
      }
    }

    // ICCID唯一校验
    const checkIccidUnique = async (rule, value, callback) => {
      if (!value) {
        // 空值不校验（由required规则处理）
        return callback()
      }

      try {
        const params = {
          uniqueType: "iccid",
          uniqueCode: value,
          excludeId: this.isEdit ? this.recordId : null
        }
        // 调用后端查重接口
        const response = await targetApi.checkUniqueCode(params)
        if (response.success && response.exists) {
          // ICCID已存在，返回错误提示
          callback(new Error('该ICCID已被使用，请更换'))
        } else {
          // ICCID可用，验证通过
          callback()
        }
      } catch (error) {
        callback(new Error('检查失败，请稍后重试'))
      }
    }

    return {
      // WebSocket通信配置
      stompClient: null,
      isConnected: false,
      wsEndpoint: config.WebSocketURL + '/ws',
      deviceTopicPrefix: '/topic/shooting-data/',
      stopReceiving: true, // 弹出新增页时开始处理数据，关闭新增页时停止处理数据

      // 表格数据
      targets: [],
      deviceTypeOptions: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      listRefreshTimer: null, // 列表刷新定时器

      // 扩展搜索
      showExtend: false,
      // 搜索表单
      searchForm: {
        orgIds: [],
        imei: '',
        iccid: '',
        deviceType: '',
        devStatus: ''
      },

      // 导入相关
      importDialogVisible: false,
      importForm: {
        file: null
      },
      fileList: [], // el-upload 组件的文件列表

      // 选中的行
      selectedIds: [],
      selectedIMEIs: [],

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增精度靶',
      isEdit: false,
      recordId: null,
      form: {
        id: null,
        warZone: '', // 隐藏战区字段
        targetNo: '', // 隐藏靶编号字段
        orgId: '',
        imei: '',
        iccid: '',
        devStatus: 1,
        version: '',
        deviceType: '',
        remark: ''
      },
      // 二维码预览弹窗
      qrCodeDialogVisible: false,
      qrCodeImageUrl: '',
      currentTarget: null,
      // 表单校验规则
      rules: {
        orgId: [
          { required: true, message: '请选择组织机构', trigger: 'change' }
        ],
        imei: [
          { required: true, message: '请输入IMEI', trigger: 'blur' },
          { min: 1, max: 50, message: 'IMEI长度在 1 到 50 个字符', trigger: 'blur' },
          { validator: checkImeiUnique, trigger: 'blur' }
        ],
        iccid: [
          { required: true, message: '请输入ICCID', trigger: 'blur' },
          { min: 1, max: 50, message: 'ICCID长度在 1 到 50 个字符', trigger: 'blur' },
          { validator: checkIccidUnique, trigger: 'blur' }
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        version: [
          { min: 1, max: 50, message: '版本信息长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        remark: [
          { min: 1, max: 200, message: '备注长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },
      userOrgs: store.state.user.userInfo.orgs,
    }
  },
  mounted() {
    this.initWebSocket(); // 初始化WebSocket连接

    // 创建定时定时器，每30秒调用loadTargets刷新列表
    this.listRefreshTimer = setInterval(() => {
      this.loadTargets();
    }, 30 * 1000); // 30000毫秒=30秒
  },
  beforeDestroy() {
    this.disconnectWebSocket(); // 断开连接

    // 清除列表刷新定时器，防止组件销毁后定时器仍运行
    if (this.listRefreshTimer) {
      clearInterval(this.listRefreshTimer);
      this.listRefreshTimer = null; // 清空变量，优化内存
    }
  },
  created() {
    // 加载设备类型选项
    this.loadDeviceTypeOptions()
    // 加载精度靶列表
    this.loadTargets()
  },
  methods: {
    // 初始化WebSocket（STOMP协议）
    initWebSocket() {
      // 1. 把SockJS包装成工厂函数传入Stomp.over
      this.stompClient = Stomp.over(() => new SockJS(this.wsEndpoint));
      
      // 2. 配置自动重连（可选，解决警告同时开启重连）
      this.stompClient.configure({
        autoReconnect: true, // 开启自动重连
        reconnectDelay: 5000, // 重连间隔5秒
        debug: () => {} // 关闭调试日志
      });

      this.stompClient.connect({}, 
        () => {
          this.isConnected = true;
          const topic = this.deviceTopicPrefix;
          this.stompClient.subscribe(topic, (msg) => {
            this.handleDeviceMessage(msg.body);
          });
        },
        (err) => {
          this.isConnected = false;
          console.error('WebSocket连接失败：', err);
        }
      );
    },
    // 处理设备推送的报文
    handleDeviceMessage(content) {
      try {
        if (this.stopReceiving) {
          return
        }
        const msgObj = JSON.parse(content);
        // 处理设备数据
        this.form.imei = msgObj.imei || '';
        this.form.iccid = msgObj.iccid || '';
        this.form.warZone = msgObj.warZone || '';
        this.form.targetNo = msgObj.targetNo || '';
      } catch (e) {
        console.error('报文解析失败：', e);
      }
    },
    // 断开WebSocket连接
    disconnectWebSocket() {
      if (this.stompClient?.connected) {
        this.stompClient.disconnect();
      }
      this.isConnected = false;
    },
    // 加载设备类型选项
    loadDeviceTypeOptions() {
      // 组装请求参数
      const params = {
        dictTypeCode: 'deviceType',
      };
      dictApi.findDictItemByDictCode(params).then(response => {
        if (response.success) {
          console.log(response.data)
          this.deviceTypeOptions = response.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载设备类型选项失败：' + error.message)
      })
    },
    // 加载精度靶列表
    loadTargets() {
      // 组装请求参数
      const params = {
        searchOrgIds: this.searchForm.orgIds,   // 搜索-组织机构ID
        imei: this.searchForm.imei,             // 搜索-IMEI
        iccid: this.searchForm.iccid,           // 搜索-ICCID
        devStatus: this.searchForm.devStatus,   // 搜索-设备状态
        deviceType: this.searchForm.deviceType, // 搜索-设备类型
        page: this.currentPage,                 // 分页-当前页
        size: this.pageSize,                    // 分页-每页条数
        userOrgIds: this.userOrgs.map(org => org.id) // 用户所负责的组织机构ID列表
      };
      targetApi.findAll(params).then(response => {
        if (response.success) {
          this.targets = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载精度靶列表失败：' + error.message)
      })
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orgIds: [],
        imei: '',
        iccid: '',
        deviceType: '',
        devStatus: ''
      }
      this.loadTargets()
    },

    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadTargets(); // 重新加载
    },

    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadTargets(); // 重新加载
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
      this.selectedIMEIs = selection.map(item => item.imei)
    },

    // 打开新增对话框
    openAddDialog() {
      if (!hasPermission('target:edit')) {
        this.$message.error('无新增精度靶权限');
        return;
      }
      this.dialogTitle = '新增精度靶'
      this.isEdit = false
      this.recordId = null
      this.form = {
        id: null,
        orgId: '',
        imei: '',
        iccid: '',
        devStatus: 1,
        deviceType: '',
        version: '',
        remark: ''
      }
      this.dialogVisible = true
      // 开始处理数据
      this.stopReceiving = false;
    },

    // 打开编辑对话框
    openEditDialog(row) {
      if (!hasPermission('target:edit')) {
        this.$message.error('无编辑精度靶权限');
        return;
      }
      this.dialogTitle = '编辑精度靶'
      this.isEdit = true
      this.recordId = row.id
      this.form = { ...row }
      this.dialogVisible = true
    },

    handleCancel() {
      this.dialogVisible = false; // 关闭对话框
      this.$refs.form.resetFields(); // 重置表单
      this.stopReceiving = true; // 停止处理数据
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新精度靶
            targetApi.update(this.form.id, this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '更新成功')
                this.dialogVisible = false
                this.$refs.form.resetFields()
                this.loadTargets()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('更新失败：' + error.message)
            })
          } else {
            // 新增精度靶
            targetApi.add(this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '新增成功')
                this.dialogVisible = false
                this.$refs.form.resetFields()
                this.stopReceiving = true; // 停止处理数据
                this.loadTargets()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('新增失败：' + error.message)
            })
          }
        }
      })
    },

    // 删除精度靶
    handleDelete(id) {
      if (!hasPermission('target:edit')) {
        this.$message.error('无删除精度靶权限');
        return;
      }
      this.$confirm('确定要删除该精度靶吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        targetApi.delete(id).then(response => {
          if (response.success) {
            this.$message.success(response.message || '删除成功')
            this.loadTargets()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('删除失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    // 批量删除精度靶
    handleBatchDelete() {
      if (!hasPermission('target:edit')) {
        this.$message.error('无批量删除精度靶权限');
        return;
      }
      if (this.selectedIds.length === 0) {
        this.$message.warning('请选择要删除的精度靶');
        return;
      }
      this.$confirm('确定要批量删除选中的精度靶吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        targetApi.deleteBatch(this.selectedIds).then(response => {
          if (response.success) {
            this.$message.success(response.message || '批量删除成功')
            this.loadTargets()
            this.selectedIds = []
            this.selectedIMEIs = []
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          this.$message.error('批量删除失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
      });
    },

    hasPermission(permCode) {
      return hasPermission(permCode);
    },

    // 导入相关方法
    openImportDialog() {
      if (!hasPermission('target:edit')) {
        this.$message.error('无导入精度靶权限');
        return;
      }
      this.importDialogVisible = true;
      this.$nextTick(() => {
        this.importForm.file = null;
      });
    },

    handleFileChange(file, fileList) {
      this.fileList = fileList;
      this.importForm.file = file.raw;
    },

    cancelImport() {
      this.fileList = [];
      this.importForm.file = null;// 清除已选择的文件
      this.importDialogVisible = false; // 关闭对话框
    },

    // 下载模板
    downloadTemplate() {
      if (!hasPermission('target:edit')) {
        this.$message.error('无下载导入模板权限');
        return;
      }
      const params = {
        userOrgIds: JSON.stringify(this.userOrgs.map(org => org.id)),
        userOrgNames: JSON.stringify(this.userOrgs.map(org => org.orgName))
      };

      targetApi.downloadTemplate(params).then(response => {
        console.log("响应状态码：", response.status);
        console.log("响应数据类型：", typeof response.data.constructor.name);
        // 处理返回的Excel二进制流，实现文件下载
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '导入模板.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        console.error("请求错误详情：", err);
        this.$message.error('模板下载失败：' + err.message);
      });
    },

    // 确认导入
    submitImport() {
      // 检查是否选择了文件
      if (!this.importForm.file) {
        this.$alert('请选择Excel文件', '提示', {
          confirmButtonText: '确定',
          type: 'warning' // 警告类型（可选，控制图标）
        });
        return;
      }

      // 构建FormData
      const formData = new FormData();
      formData.append('file', this.importForm.file); // 添加文件
      formData.append('userOrgIds', JSON.stringify(this.userOrgs.map(org => org.id))); // 添加用户组织ID

      // 调用API
      targetApi.importTargets(formData).then(response => {
        const result = response;
        if (result.success) {
          this.$message.success(`导入成功：成功${result.successCount}条，失败${result.failCount}条`);
          // 显示失败详情（如有）
          if (result.failMessages && result.failMessages.length > 0) {
            this.$alert(result.failMessages.join('<br>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.importDialogVisible = false;
          this.loadTargets(); // 刷新精度靶列表
          this.cancelImport();
        } else {
          this.$message.error(result.failMessages || '导入失败');
        }
      }).catch(err => {
        this.$message.error(`导入失败：${err.message || '服务器错误'}`);
      });
    },

    // 批量导出
    exportTargets() {
      if (!hasPermission('target:edit')) {
        this.$message.error('无导出精度靶权限');
        return;
      }
      // 准备导出参数（检索条件 + 用户组织ID）
      const params = {
        searchOrgIds: this.searchForm.orgIds.length > 0 ? JSON.stringify(this.searchForm.orgIds) : '',
        imei: this.searchForm.imei || '',
        iccid: this.searchForm.iccid || '',
        devStatus: this.searchForm.devStatus || '',
        userOrgIds: JSON.stringify(this.userOrgs.map(org => org.id)) // 用户组织ID（必传，用于权限过滤）
      };

      // 调用API
      targetApi.exportTargets(params).then(response => {
        // 处理二进制流，创建下载链接
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `精度靶列表_${new Date().getTime()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        this.$message.error(`导出失败：${err.message || '网络错误'}`);
      });
    },

    // 预览二维码
    previewQrCode(target) {
      this.currentTarget = target;
      this.qrCodeImageUrl = `${config.WebSocketURL}/api/target/qrcode/generate/${target.imei}`;
      this.qrCodeDialogVisible = true;
    },

    // 下载单个二维码
    downloadSingleQrCode(target) {
      const link = document.createElement('a');
      link.href = `${config.WebSocketURL}/api/target/qrcode/generate/${target.imei}`;
      link.download = `精度靶二维码_${target.imei}.png`;
      link.click();
    },

    // 批量下载二维码
    batchDownloadQrCode() {
      if (!this.selectedIMEIs || this.selectedIMEIs.length === 0) {
        this.$message.warning('请先选择要下载的设备');
        return;
      }
      if (this.selectedIMEIs.length > 100) {
        this.$message.warning('一次最多下载100个二维码，请分批选择');
        return;
      }
      targetApi.batchGenerate(this.selectedIMEIs).then(response => {
        // 只有200状态码才处理下载
        if (response.status !== 200) {
          throw new Error('请求失败');
        }
        // 处理二进制流
        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        a.download = `精度靶二维码_${dateStr}.zip`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        // 解析错误信息（如果后端返回了JSON错误）
        let errorMsg = '批量下载失败，请重试';
        if (err.response && err.response.data) {
          try {
            // 尝试解析blob里的错误信息
            const reader = new FileReader();
            reader.onload = function() {
              const result = JSON.parse(reader.result);
              errorMsg = result.message || errorMsg;
            };
            reader.readAsText(err.response.data);
          } catch (e) {}
        }
        this.$message.error(errorMsg);
        console.error('批量下载错误：', err);
      });
    },

    // 打印二维码
    printQrCode() {
      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const win = iframe.contentWindow;
      const doc = win.document;

      win.__onQrLoad = function() {
        setTimeout(() => {
          win.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 200);
        }, 100);
      };

      win.__onQrError = function() {
        this.$message.error('二维码图片加载失败，请重试');
        document.body.removeChild(iframe);
      }.bind(this);

      doc.write(`
        <html>
          <head>
            <title>精度靶二维码打印</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 20px; 
                text-align: center;
                font-family: "Microsoft Yahei", sans-serif;
              }
            </style>
          </head>
          <body>
            <img 
              class="qr-code" 
              src="${this.qrCodeImageUrl}" 
              alt="二维码"
              onload="window.__onQrLoad()"
              onerror="window.__onQrError()"
            />
          </body>
        </html>
      `);

      doc.close();
    },

    // 批量打印二维码
    batchPrintQrCode() {
      if (!this.selectedIMEIs || this.selectedIMEIs.length === 0) {
        this.$message.warning('请先选择要打印的设备');
        return;
      }

      if (this.selectedIMEIs.length > 100) {
        this.$message.warning('一次最多打印100个二维码，请分批选择');
        return;
      }

      const iframe = document.createElement('iframe');
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const win = iframe.contentWindow;
      const doc = win.document;

      // 关键：在iframe的window上定义全局回调函数
      const totalImages = this.selectedIMEIs.length;
      let loadedCount = 0;

      win.__onQrLoad = function() {
        loadedCount++;
        if (loadedCount === totalImages) {
          setTimeout(() => {
            win.print();
          }, 100);
        }
      }.bind(this);

      win.__onQrError = function(index) {
        this.$message.error(`设备 ${this.selectedIMEIs[index]} 的二维码加载失败`);
        win.__onQrLoad(); // 失败也计数，避免卡住
      }.bind(this);

      // 生成HTML，直接在img标签内绑定事件
      let htmlContent = `
        <html>
          <head>
            <title>设备二维码批量打印</title>
            <style>
              @page { 
                margin: 0; 
                size: A4;
              }
              body { 
                margin: 0; 
                padding: 0;
                font-family: "Microsoft Yahei", sans-serif;
              }
              .qr-item {
                width: 100%;
                height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                page-break-after: always;
              }
              .qr-item:last-child {
                page-break-after: avoid;
              }
            </style>
          </head>
          <body>
      `;

      this.selectedIMEIs.forEach((imei, index) => {
        const qrUrl = `${config.WebSocketURL}/api/target/qrcode/generate/${imei}`;
        // 直接在img标签里绑定onload和onerror事件
        htmlContent += `
          <div class="qr-item">
            <img 
              class="qr-code" 
              src="${qrUrl}" 
              alt="二维码"
              onload="window.__onQrLoad()"
              onerror="window.__onQrError(${index})"
            />
          </div>
        `;
      });

      htmlContent += `
          </body>
        </html>
      `;

      doc.write(htmlContent);
      doc.close();
    }
  }
}
</script>

<style scoped></style>